import posthog from "posthog-js";
import type { CaptureResult } from "posthog-js";

const HANDOFF_EVENTS = new Set([
  "extension_auth_handoff_completed",
  "extension_auth_handoff_failed",
]);
const HANDOFF_PROPERTIES = new Set([
  "distinct_id", "$session_id", "$window_id", "$lib", "$lib_version",
  "$insert_id", "$process_person_profile", "$is_identified", "token",
  "flow", "schema_version", "outcome", "failure_reason",
]);

/** Keep SDK identity/settings, excluding inherited URL, attribution and content. */
export function sanitizeExtensionAuthEvent(event: CaptureResult | null): CaptureResult | null {
  if (!event || !HANDOFF_EVENTS.has(event.event)) return event;
  const safe = { ...event };
  delete safe.$set;
  delete safe.$set_once;
  return {
    ...safe,
    properties: Object.fromEntries(
      Object.entries(event.properties || {}).filter(([key]) => HANDOFF_PROPERTIES.has(key)),
    ),
  };
}

export function captureExtensionAuthHandoff(outcome: "completed" | "failed", uid: string): void {
  try {
    posthog.capture(`extension_auth_handoff_${outcome}`, {
      distinct_id: uid,
      flow: "extension_auth_handoff_v1",
      schema_version: 1,
      outcome,
      ...(outcome === "failed" && { failure_reason: "not_acknowledged" }),
    });
  } catch {
    // Observability must not change authentication behavior.
  }
}
